import ContentLoader from 'react-content-loader';

import { useSkeletonColors } from 'hooks';

export default function HelpCenterLoader() {
  const skeletonColors = useSkeletonColors();

  return (
    <ContentLoader
      speed={2}
      width="100%"
      height="800px"
      {...skeletonColors}
    >
      <rect x="0" y="0" rx="3" ry="3" width="50%" height="40px" />
      <rect x="0" y="80px" rx="3" ry="3" width="90%" height="20px" />
      <rect x="0" y="110px" rx="3" ry="3" width="90%" height="250px" />
      <rect x="0" y="380px" rx="3" ry="3" width="15%" height="40px" />
    </ContentLoader>
  );
}
